<template>
  <main class="about">
    <div class="page-header">
      <h1>About</h1>
    </div>
    <div class="page-content">
      <section>
        <div class="section-heading">
          <h2>What is the Pomodoro Technique?</h2>
        </div>
        <div class="section-content">
          <p>The Pomodoro Technique is a time management strategy developed by Francesco Cirillo in the late 1980s. It gets its name from the tomato-shaped kitchen timers, which Cirillo used as a college student.</p>
          <p>The basic steps of the technique are:</p>
          <ol>
            <li>Choose a task to be done.</li>
            <li>Set the timer for 25 minutes.</li>
            <li>Do the task.</li>
            <li>Take a 5 minute break. After every 4th pomodoro, take a longer break (15–30min).</li>
            <li>Repeat for the number of pomodoros you’d like to complete in the day.</li>
          </ol>
          <p>In the technique, a “pomodoro” is the time interval that the participant is focused on a task. During a pomodoro, the goal is to eliminate distraction and achieve focus or flow on the given to–do item. This could mean turning off notifications, closing email, chat apps, refraining from surfing the web, etc.</p>
        </div>
      </section>
      <section>
        <div class="section-heading">
          <h2>Why is the Pomodoro Technique so effective?</h2>
        </div>
        <div class="section-content">
          <p>The Pomodoro Technique has a number of benefits, some of which are core to the method, while others are secondary results. It’s great because:
</p>
          <ul>
            <li>It helps you stay focused by encouraging the elimination of distractions.</li>
            <li>It helps with productivity by relating to the idea of <a href="https://en.wikipedia.org/wiki/Timeboxing" rel="noopener" target="_blank">timeboxing,</a> or setting a fixed amount of time to accomplish tasks.</li>
            <li>It helps with project planning and being more deliberate about what needs to be done.</li>
            <li>It helps with posture and back pain by encouraging participants to get out of their seat every half hour.</li>
            <li>It’s an informal and lightweight way of tracking daily progress. By marking how many pomodoros were completed in a day, you can easily see the time spent working.</li>
          </ul>
        </div>
      </section>
      <section>
        <div class="section-heading">
          <h2>Who made this?</h2>
        </div>
        <div class="section-content">
          <p>Have ideas for how to improve the timer? Found a bug? TomatoTicker was made by <a href="http://f-larocca.com" rel="noopener" target="_blank">Frank LaRocca,</a> who you can reach at info[at]tomatoticker.com.</p>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import stateMutations from '@/mixins/stateMutations'

export default {
  name: 'About',
  mixins: [stateMutations],
  metaInfo: {
    title: 'About TomatoTicker',
    meta: [
      { name: 'description', content: 'The timer works with the Pomodoro Technique, which is a time management strategy.' },
      { property: 'og:title', content: 'About TomatoTicker' },
      { property: 'og:url', content: 'https://tomatoticker.com' },
      { property: 'og:description', content: 'The timer works with the Pomodoro Technique, which is a time management strategy.' },
      { property: 'og:image', content: 'https://tomatoticker.com/images/og-image.png' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@tomatoticker' }
    ]
  },
  created: function () {
    this.timerIsRunning = false
  }
}
</script>
